// core version + navigation, pagination modules:
import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

// import Swiper and modules styles
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

// animate.css
import "animate.css";

// import core theme styles
import "./index.scss";

const partnerSwiper = new Swiper(".partner-swiper", {
  modules: [Navigation],

  // Optional parameters
  slidesPerView: 1,
  spaceBetween: 75,

  breakpoints: {
    767: {
      slidesPerView: 2,
    },

    991: {
      slidesPerView: 3,
    },

    1440: {
      slidesPerView: 5,
    },
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const productSwiper = new Swiper(".product-swiper", {
  modules: [Navigation, Autoplay],

  // Optional parameters
  slidesPerView: 2,
  spaceBetween: 50,
  speed: 2000,
  direction: "horizontal",

  autoplay: {
    delay: 1500,
    disableOnInteraction: false,
  },
  loop: true,

  breakpoints: {
    767: {
      slidesPerView: 3,
      speed: 2000,
      autoplay: {
        delay: 1500,
        disableOnInteraction: false,
      },
      loop: true,
    },

    850: {
      slidesPerView: 4,
    },
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const affiliationSwiper = new Swiper(".affiliation-swiper", {
  modules: [Navigation],

  // Optional parameters
  slidesPerView: 1,
  spaceBetween: 75,

  breakpoints: {
    767: {
      slidesPerView: 3,
    },

    991: {
      slidesPerView: 4,
    },

    1200: {
      slidesPerView: 5,
    },
  },

  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

const locationSwiper = new Swiper(".location-swiper", {
  modules: [Navigation],

  // Optional parameters
  slidesPerView: 2,
  spaceBetween: 20,

  breakpoints: {
    767: {
      slidesPerView: 3,
      spaceBetween: 20,
    },

    991: {
      slidesPerView: 4,
      spaceBetween: 20,
    },

    1440: {
      slidesPerView: 5,
      spaceBetween: 3,
    },
  },

  navigation: {
    nextEl: ".location-button-next",
    prevEl: ".location-button-prev",
  },
});

const gallerySwiper = new Swiper(".gallery-swiper", {
  modules: [Navigation],

  // Optional parameters
  slidesPerView: 1,
  spaceBetween: 40,

  breakpoints: {
    767: {
      slidesPerView: 2,
    },

    1200: {
      slidesPerView: 3,
    },
  },

  navigation: {
    nextEl: ".gallery-button-next",
    prevEl: ".gallery-button-prev",
  },
});

/* location */
const locations = document.querySelectorAll(".location-items .location");
if (locations.length > 0) {
  const locationFeatImg = document.querySelector(".location-featured-image");
  const locationFeatWrapper = document.querySelector(".locationImageWrapper");

  locationFeatImg.setAttribute("src", locationImages[0]);
  locationFeatWrapper.style.backgroundImage =
    "url('" + locationImages[0] + "')";

  let locationItemCount = 1;
  locations.forEach((location) => {
    const description = location.querySelector(".description");
    const heading = location.querySelector("h5");
    if (locationItemCount == 1) {
      location.querySelector(".location-container").classList.add("active");
    }

    heading.setAttribute("data-index", locationItemCount - 1);
    locationItemCount++;
  });

  locations.forEach((location) => {
    const heading = location.querySelector("h5");

    heading.addEventListener("click", function (ev) {
      const currentLocationContainer = heading.parentElement;
      const locationsContainer = document.querySelectorAll(
        ".location-container"
      );

      locationsContainer.forEach((singleLocationContainer) => {
        singleLocationContainer.classList.remove("active");
      });

      locationFeatImg.setAttribute(
        "src",
        locationImages[heading.getAttribute("data-index")]
      );
      locationFeatWrapper.style.backgroundImage =
        "url('" + locationImages[heading.getAttribute("data-index")] + "')";

      currentLocationContainer.classList.add("active");
    });
  });
}

/* Nav */
const navigation = document.querySelector(".navigation");
const navItems = document.querySelector(".nav-items");
const navButton = document.querySelector(".nav-button");

navButton.addEventListener("click", function (ev) {
  ev.preventDefault();
  navigation.classList.toggle("open");
  navItems.classList.toggle("active");
});

/* Sub Menu Display */
const hasSubMenu = navigation.querySelector("ul li.menu-item-has-children > a");
hasSubMenu?.addEventListener("click", function (ev) {
  ev.preventDefault();
  hasSubMenu.parentElement.classList.toggle("sub-menu-active");
});

/* design page set active  */
const urlParams = new URLSearchParams(window.location.search);
const locationQueryVar = urlParams.get("loc");

if (locationQueryVar) {
  const locationSwiperSlide = document.querySelector(
    ".location-swiper .swiper-wrapper .single-location[data-location-slug = '" +
      locationQueryVar +
      "']"
  );

  locationSwiper.slideTo(locationSwiperSlide.getAttribute("data-index"));
}

/* gallery load */
const galleryImageWrappers = document.querySelectorAll(
  ".gallery-image-wrapper"
);

galleryImageWrappers.forEach((galleryImageWrapper) => {
  const img = galleryImageWrapper.querySelector("img");

  function loaded() {
    galleryImageWrapper.classList.add("loaded");
  }

  if (img.complete) {
    loaded();
  } else {
    img.addEventListener("load", loaded);
  }
});

/* single-designer on click handler - show designer modal */

const designers = document.querySelectorAll(".single-designer");
designers.forEach((singleDesigner) => {
  singleDesigner.addEventListener("click", async function () {
    const designerModal = document.querySelector(".designer-modal");
    const designerId = singleDesigner.getAttribute("data-designer-id");

    designerModal.querySelector(".designer-image img").style.display = "none";
    designerModal.querySelector("h4").textContent = "";
    designerModal.querySelector("p.designer-position").textContent =
      "Loading...";
    designerModal.querySelector("p.designer-location").textContent = "";
    designerModal.querySelector("p.designer-description").innerHTML = "";

    designerModal.classList.add("active");
    document.body.classList.add("no-scroll");

    const designerData = await fetch(
      window.location.origin +
        "/wp-json/wp/v2/designer?_embed&include=" +
        designerId
    );
    const data = await designerData.text();
    const parsedData = JSON.parse(data);

    const name = parsedData[0].title.rendered;
    const description = parsedData[0].content.rendered;
    const featuredImage =
      parsedData[0]._embedded["wp:featuredmedia"]["0"].source_url;
    const designerTitle =
      parsedData[0]["toolset-meta"]["designer-options"]["designer-title"].raw;
    const location =
      parsedData[0]["toolset-meta"]["designer-options"]["designer-location"]
        .raw;

    const designerLocation = await fetch(
      window.location.origin +
        "/wp-json/wp/v2/location?_embed&include=" +
        location
    );

    const locationData = await designerLocation.text();
    const locationParsedData = JSON.parse(locationData);

    const locationName = locationParsedData[0].title.rendered;

    designerModal
      .querySelector(".designer-image img")
      .setAttribute("src", featuredImage);
    designerModal
      .querySelector(".designer-image img")
      .setAttribute("alt", name);
    designerModal.querySelector("h4").textContent = name;
    designerModal.querySelector("p.designer-position").textContent =
      designerTitle;
    designerModal.querySelector("p.designer-location").textContent =
      locationName;
    designerModal.querySelector("p.designer-description").innerHTML =
      description;

    designerModal.querySelector(".designer-image img").style.display = "block";

    designerModal
      .querySelector(".close-modal")
      .addEventListener("click", function (ev) {
        ev.preventDefault();

        designerModal.classList.remove("active");
      });
  });
});

/* Event Page Functionality */
const eventsWrapper = document.querySelector(".events-wrapper");
const singleEventContentContainer = document.querySelector(
  ".single-event-content-container"
);

/* Events sort functionality */

const sortOptionsContainer = document.querySelector(".sort-options");
const sortButton = document.querySelector(".sort-button");
const allEventLink = document.querySelectorAll(".single-event-permalink");
const loading = document.querySelector(".loading");
const singleEventTitle = document.querySelector(
  ".single-event-content .event-title"
);
const singleEventContent = document.querySelector(
  ".single-event-content .single-event-content"
);
const backToEventsBtn = document.querySelector(".back-to-events");
const sortAlphaInputAll = document.querySelectorAll("input[name='sort-alpha']");
const sortDateInputAll = document.querySelectorAll("input[name='sort-date']");

sortButton?.addEventListener("click", () => {
  sortOptionsContainer.classList.toggle("hidden");
  sortButton.classList.toggle("active");
});

allEventLink?.forEach((singleEventLink) => {
  singleEventLink.addEventListener("click", async (ev) => {
    ev.preventDefault();

    eventsWrapper.classList.add("hidden");
    const eventID = singleEventLink.getAttribute("data-event-id");

    loading.classList.add("active");

    await fetchPostById(eventID).then((postData) => {
      singleEventTitle.textContent = postData.title.rendered;
      singleEventContent.innerHTML = postData.content.rendered;
      singleEventContentContainer.classList.add("active");
      loading.classList.remove("active");
      window.scrollTo({
        top: document.querySelector(".single-event-content-container")
          .offsetTop,
      });

      location.hash = postData.slug;
    });
  });
});

backToEventsBtn?.addEventListener("click", () => {
  singleEventContentContainer.classList.remove("active");
  eventsWrapper.classList.remove("hidden");
  window.scrollTo({
    top: eventsWrapper.offsetTop,
  });

  history.pushState(
    "",
    document.title,
    window.location.pathname + window.location.search
  );
});

/*window.addEventListener("hashchange", async () => {
  if (location.href.indexOf("events") > -1) {
    const eventSlug = location.hash;

    if (eventSlug == "") {
      backToEventsBtn.click();
      return;
    }

    await fetchPostBySlug(eventSlug).then((postData) => {
      singleEventTitle.textContent = postData.title.rendered;
      singleEventContent.innerHTML = postData.content.rendered;
      singleEventContentContainer.classList.add("active");
      window.scrollTo({
        top: document.querySelector(".single-event-content-container")
          .offsetTop,
      });

      location.hash = postData.slug;
    });
  
  }
});*/

const fetchPostById = async (eventID) => {
  const fsbRESTURL =
    window.location.origin + "/wp-json/wp/v2/event?include[]=" + eventID;

  return await fetch(fsbRESTURL)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data[0];
    });
};

const fetchPostBySlug = async (eventSlug) => {
  const fsbRESTURL =
    window.location.origin + "/wp-json/wp/v2/event?slug=" + eventSlug;

  return await fetch(fsbRESTURL)
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      return data[0];
    });
};

sortAlphaInputAll?.forEach((sortAlphaInput) => {
  sortAlphaInput?.addEventListener("change", async (ev) => {
    if (sortAlphaInput.checked) {
      window.location.href =
        window.location.origin +
        "/events?orderby=title&order=" +
        sortAlphaInput.value;
    }
  });
});

sortDateInputAll?.forEach((sortDateInput) => {
  sortDateInput?.addEventListener("change", async (ev) => {
    if (sortDateInput.checked) {
      window.location.href =
        window.location.origin + "/events?order=" + sortDateInput.value;
    }
  });
});
